module.exports = __webpack_public_path__ + "img/user-card.eae03044.jpg";